module.exports = __webpack_public_path__ + "assets/images/hemoglobin_y.ddf4110d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/risks/hemoglobin_y.png
// module id = 734
// module chunks = 1